import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withToast } from "../contexts/toastr.context";
import plusGrayIcon from "../_assets/vectors/plus-gray-icon.svg";
import I18 from "./atoms/i18";
import IconButton from "./icon-button.component";
import { Modal } from "./modal.component";
import CopyTextField from "./molecule/copy-text-field.component";
import ShareOnSocialMedia from "./molecule/share-on-social-media.component";

function ShareTextModalComponent({
  heading = "",
  text = "",
  active = false,
  setActive = (e) => {},
  onClose = (e) => {},
}) {
  if (!active) {
    return null;
  }
  return (
    <Modal
      className="ShareTextModal"
      active={active}
      setActive={setActive}
      padding={false}>
      <div className="pb-4">
        {/* Heading */}
        <div className="flex items-center justify-between space-x-2 bg-card p-1 pl-4">
          <span className="my-2 font-semibold">{heading}</span>
          <IconButton icon={plusGrayIcon} rotate={45} onClick={onClose} />
        </div>
        {/* Body */}
        <div className="my-2 px-4 font-semibold text-secondary-foreground/85">
          <I18>Share via link</I18>
        </div>
        <CopyTextField text={text} className="mx-3 bg-card" />
        <ShareOnSocialMedia text={text} className="mt-4" />
      </div>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth,
  community: state.community,
  groups: state.groups,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const ShareTextModal = withToast(
  connect(mapStateToProps, mapDispatchToProps)(ShareTextModalComponent)
);

export { ShareTextModal };
